var _path, _path2, _rect, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPkg = function SvgPkg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pkg_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    fillRule: "evenodd",
    d: "M20.25 24a1.5 1.5 0 0 0-1.5 1.5V27h16.5v-1.5a1.5 1.5 0 0 0-1.5-1.5zm-1.5 4.5h6.75v3a1.5 1.5 0 0 0 3 0v-3h6.75v9a1.5 1.5 0 0 1-1.5 1.5h-13.5a1.5 1.5 0 0 1-1.5-1.5z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#FE0066",
    rx: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.484 18v-6h2.59q.668 0 1.169.264.5.264.779.74.278.479.278 1.117 0 .645-.287 1.116-.284.472-.8.727-.511.255-1.198.255H8.468v-1.266h1.219q.286 0 .49-.1a.73.73 0 0 0 .313-.29.85.85 0 0 0 .111-.442.83.83 0 0 0-.111-.44.7.7 0 0 0-.314-.28 1.1 1.1 0 0 0-.489-.1h-.574V18zm5.414 0v-6h1.629v2.426h.082L16.414 12h1.898l-2.027 2.672L18.359 18h-1.945l-1.348-2.25-.54.703V18zm9.415-4.02a.8.8 0 0 0-.12-.272.838.838 0 0 0-.486-.328 1.3 1.3 0 0 0-.349-.044 1.2 1.2 0 0 0-.7.196q-.287.197-.44.566-.15.37-.149.89 0 .528.144.903.143.375.427.574.285.2.706.2.372 0 .619-.11a.8.8 0 0 0 .372-.307.87.87 0 0 0 .123-.469l.281.03H21.37v-1.16h2.66v.832q0 .82-.349 1.403-.345.58-.955.89-.606.308-1.391.308-.876 0-1.538-.372a2.6 2.6 0 0 1-1.035-1.06q-.369-.69-.369-1.638 0-.744.226-1.319.228-.574.633-.97.404-.397.934-.6a3.1 3.1 0 0 1 1.137-.205q.533 0 .99.152.46.15.812.428.355.275.571.653.217.378.264.83z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pkg_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgPkg;